export default {
  container: {},
  sectionTitle: {
    display: 'flex',
    aliginItems: 'center',
    justifyContent: 'center'
  },
  panelTitle: {
    width: '125px',
    fontFamily: 'AvenirNext',
    fontSize: '15px',
    color: '#4f4c75',
    paddingBottom: '7px',
    borderBottom: '3px solid transparent',
    margin: '0 12.5px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '15px'
  },
  panelTitleActive: {
    width: '125px',
    fontFamily: 'AvenirNext',
    fontSize: '15px',
    color: '#4f4c75',
    paddingBottom: '7px',
    borderBottom: '3px solid #887fff',
    margin: '0 12.5px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '15px'
  },
  panelContent: {}
}